// Content for the /pricing page. Plan prices and slider tiers come from
// pages/auth/components/planSelectionData.ts (shared with sign-up).

/** When the promo banner's countdown ends. TODO: set the real offer end date. */
export const OFFER_END = '2026-11-30T23:59:59+07:00';

export const OFFER = {
  title: '2-year plans · +1 year free',
  subtitle: 'Launch offer: save up to 70% on every plan',
};

/** Feature comparison. A string is shown as text, true = included, false = not included. */
type Cell = boolean | string;
export interface CompareRow {
  name: string;
  hint?: string;
  values: [Cell, Cell, Cell]; // Starter, Growth Pro, Enterprise VIP
}

export const compareGroups: { title: string; rows: CompareRow[] }[] = [
  {
    title: 'Members & POS',
    rows: [
      { name: 'Digital QR member cards', hint: 'Instant point issue & redeem', values: [true, true, true] },
      { name: 'Active members / month', values: ['Single store', '300 – 3,000', 'Unlimited'] },
      { name: 'Store outlets', values: ['1 or 3', 'Per store', '300 – 3,000 branches'] },
      { name: 'Cloud Cashier POS', values: ['100 tx/mo', 'Unlimited', 'Unlimited'] },
      { name: 'Member SMS notifications', values: ['20 msg/mo', 'Volume pricing', 'Best volume pricing'] },
    ],
  },
  {
    title: 'Marketing & rewards',
    rows: [
      { name: 'Membership tiers', hint: 'Bronze, Silver, Gold', values: [true, true, true] },
      { name: 'Birthday rewards & digital coupons', values: [false, true, true] },
      { name: 'Spin-to-win & VIP tier cards', values: [false, true, true] },
      { name: 'Scheduled notifications & segment blasts', values: [false, true, true] },
      { name: 'AI Campaign Generator', values: [false, '5× / day', true] },
      { name: 'Cross-brand loyalty alliances & point swaps', values: [false, false, true] },
    ],
  },
  {
    title: 'Integrations',
    rows: [
      { name: 'Telegram & WhatsApp mini-app', values: [false, true, true] },
      { name: 'Cross-store points redemption', values: [false, true, true] },
      { name: 'CSV / Excel ledger export', values: [false, true, true] },
      { name: 'Open REST API & webhooks', hint: 'For custom platforms', values: [false, false, true] },
      { name: 'White-label portal & receipts', values: [false, false, true] },
      { name: 'Real-time cross-branch clearing', values: [false, false, true] },
    ],
  },
  {
    title: 'Ledger & support',
    rows: [
      { name: 'Secure cloud ledger storage', values: ['50 GB', '50 GB', '50 GB'] },
      { name: 'Dedicated technical architect & 24/7 SLA', values: [false, false, true] },
      { name: 'Dedicated account manager', values: [false, false, true] },
    ],
  },
];

export const pricingFaqs = [
  {
    q: 'What is the difference between Starter, Growth Pro and Enterprise VIP?',
    a: 'Starter runs a loyalty program for one or three outlets. Growth Pro adds automated marketing, coupons and messaging apps for 300 to 3,000 active members. Enterprise VIP is for chains: unlimited stores, the open API, white-label branding and a dedicated team.',
  },
  {
    q: 'Does my plan renew automatically?',
    a: 'No. Plans activate instantly and do not auto-renew. We remind you before the term ends.',
  },
  {
    q: 'What does “+1 year free” on 2-year plans mean?',
    a: 'Pay for a 2-year term during the offer and your plan runs for 3 years (36 months). The price shown is the total for the full term.',
  },
  {
    q: 'What counts as an active member?',
    a: 'A member who earns or redeems points during the month. Members who do nothing that month are not counted.',
  },
  {
    q: 'Can I change plans later?',
    a: 'Yes. Upgrade at any time and the remaining value of your current plan is credited. Contact us to move to a smaller plan.',
  },
  {
    q: 'Which hardware works with LoyaltyBridge?',
    a: '2D QR and barcode scanners, cloud thermal receipt printers, cash drawers, and iPad or Android tablets running the POS app. An offline cashier mode keeps checkouts working without internet.',
  },
  {
    q: 'Do I need a developer?',
    a: 'Not for Starter or Growth Pro: everything is set up in the dashboard. Enterprise VIP includes the open REST API and webhooks for teams that connect their own systems.',
  },
  {
    q: 'Is my member data secure?',
    a: 'API keys are hashed and scoped, every change is recorded in an audit log, and all traffic is encrypted.',
  },
];
